import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const PriorityCalls = () => {
    const { chartData } = useServicesChartsDataContext();

    const colorMap = {
        'AZUL': '#1C64F2',
        'VERDE': '#31C48D',
        'AMARELO': '#fbff00',
        'VERMELHO': '#E02424',
        'Não Informada': '#0F0F0F',
        'LARANJA': '#fa9600'
    };

    const dynamicColors = chartData?.priorityCalls?.series?.map(
        s => colorMap[s.name] || '#CCCCCC'
    );

    return (
        <SimpleBars
            title="Ocorrências por prioridade do chamado"
            subtitles={chartData?.priorityCalls?.categories}
            series={chartData?.priorityCalls?.series}
            stacked={true}
            customColors={dynamicColors}
        />
    );
};